"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_1 = require("utils/browser");
class MictapPlayer {
    constructor(videoEl, videoControls) {
        this.hasSetCustomControls = false;
        this.videoEl = videoEl;
        this.setVideoControls(videoControls);
    }
    setVideoControls(videoControls) {
        let controlsHTML = `<button type="button" class="play-button cursor-pointer w-16 btn btn-secondary px-2 py-1">Play</button>
          <div class="flex-grow px-2 md:px-4">
            <div class="relative">
              <input type="range" value="0" class="seek-bar w-full slider">
            </div>
          </div>
          <button class="hidden cursor-pointer w-1/5 replay-button btn btn-secondary py-1 px-2" type="button">Replay</button>
          <button class="hidden cursor-pointer w-1/5 mute-button" type="button">Mute</button>
          <button class="cursor-pointer w-10 text-white fullscreen-button hover:bg-white hover:text-blue-600 rounded-md" type="button">
            <!-- Full screen icon -->
            <svg class="w-6 h-6 mx-auto fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M6.987 10.987l-2.931 3.031L2 11.589V18h6.387l-2.43-2.081 3.03-2.932-2-2zM11.613 2l2.43 2.081-3.03 2.932 2 2 2.931-3.031L18 8.411V2h-6.387z"/></svg>
          </button>`;
        videoControls.innerHTML = controlsHTML;
        this.playButton = videoControls.querySelector(".play-button");
        this.muteButton = videoControls.querySelector(".mute-button");
        this.replayButton = videoControls.querySelector(".replay-button");
        this.fullScreenButton = videoControls.querySelector(".fullscreen-button");
        this.seekBar = videoControls.querySelector(".seek-bar");
    }
    setCurrentTime(currentTime) {
        this.videoEl.currentTime = currentTime;
    }
    setupCustomControls() {
        var _a, _b, _c;
        // Video
        if (this.videoEl == null) {
            console.error("Video element is null");
            return;
        }
        ;
        this.videoEl.muted = false;
        this.videoEl.volume = 1;
        if (this.hasSetCustomControls)
            return;
        this.hasSetCustomControls = true;
        // Event listener for the play/pause button
        // element.removeEventListener("mousedown", handleMouseDown, false);
        (_a = this.playButton) === null || _a === void 0 ? void 0 : _a.addEventListener("click", this.handlerPlayPauseButton.bind(this));
        (_b = this.muteButton) === null || _b === void 0 ? void 0 : _b.addEventListener("click", this.handlerMuteButton.bind(this));
        (_c = this.replayButton) === null || _c === void 0 ? void 0 : _c.addEventListener("click", () => {
            this.videoEl.currentTime = 0.01;
        });
        const browser = (0, browser_1.detectBrowser)(window);
        // Hide fullscreen button in safari
        if (browser.browser === 'safari' && browser.version >= 605 && browser.iphone) {
            if (this.playButton)
                this.playButton.style.width = "20%";
        }
        else {
            if (browser.ipad) {
                if (this.fullScreenButton)
                    this.fullScreenButton.style.display = "none";
            }
            if (this.fullScreenButton)
                this.fullScreenButton.addEventListener("click", this.handlerFullscreen.bind(this));
        }
        // Seekbar events
        this.videoEl.addEventListener("timeupdate", this.handlerSeekBarTimeUpdate.bind(this));
        this.videoEl.addEventListener("ended", () => {
            // Safari IOS is not able to move the current time to 0.01 for some reason
            // so we are unloading and reloading the same clip, of course this is a bit
            // worse for data usage, where its most needed, but we havent found a way to
            // make it work otherwise.
            if (browser.browser === 'safari' && browser.version >= 605 && browser.iphone) {
                let url = this.videoEl.src;
                this.videoEl.src = "";
                this.videoEl.src = url;
                this.videoEl.pause();
            }
            this.seekBar.value = "0";
            this.videoEl.currentTime = 0.01;
            // this.replayButton.classList.remove("hidden");
            this.playButton.innerHTML = "Play";
        });
        this.seekBar.addEventListener("change", this.handlerSeekBarChange.bind(this));
        // seekBar.addEventListener("mousedown", this.handlerPauseVideo);
        // seekBar.addEventListener("mouseup", this.handlerPlayVideo);
    }
    handlerPlayPauseButton() {
        if (this.videoEl.paused == true) {
            this.videoEl.play();
            this.playButton.innerHTML = "Pause";
        }
        else {
            this.videoEl.pause();
            this.playButton.innerHTML = "Play";
        }
    }
    handlerMuteButton() {
        if (this.videoEl.muted == false) {
            this.videoEl.muted = true;
            this.muteButton.innerHTML = "Unmute";
        }
        else {
            this.videoEl.muted = false;
            this.muteButton.innerHTML = "Mute";
        }
    }
    handlerFullscreen() {
        if (this.videoEl.requestFullscreen) {
            this.videoEl.requestFullscreen();
            // @ts-ignore: mozilla fullscreen
        }
        else if (this.videoEl.mozRequestFullScreen) {
            // @ts-ignore: mozilla fullscreen
            this.videoEl.mozRequestFullScreen(); // Firefox
            // @ts-ignore: chrome fullscreen
        }
        else if (this.videoEl.webkitRequestFullscreen) {
            // @ts-ignore chrome fullscreen
            this.videoEl.webkitRequestFullscreen(); // Chrome and Safari
        }
    }
    handlerPauseVideo() {
        this.videoEl.pause();
    }
    handlerPlayVideo() {
        this.videoEl.play();
    }
    handlerSeekBarChange() {
        var time = this.videoEl.duration * (parseFloat(this.seekBar.value) / 100);
        this.videoEl.currentTime = time;
    }
    handlerSeekBarTimeUpdate() {
        var value = (100 / this.videoEl.duration) * this.videoEl.currentTime;
        this.seekBar.value = value.toString();
    }
}
exports.default = MictapPlayer;
